export default "__VITE_ASSET__47b42fb7__"